export default "__VITE_ASSET__d0d21fe7__"